import { useDataChange } from 'Simple/Data.js'

import {
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfQuarter,
  endOfQuarter,
  startOfYear,
  endOfYear,
  subWeeks,
  subMonths,
  subQuarters,
  subYears,
  addWeeks,
  addMonths,
  addQuarters,
  addYears,
} from 'date-fns'

let today = new Date()
let lastWeek = subWeeks(today, 1)
let lastMonth = subMonths(today, 1)
let lastQuarter = subQuarters(today, 1)
let lastYear = subYears(today, 1)

let nextWeeks = (weeks = 1) => addWeeks(today, weeks)
let nextMonth = addMonths(today, 1)
let nextQuarter = addQuarters(today, 1)
let nextYear = addYears(today, 1)

export let DATE_RANGE_TEMPLATES_HANDLER = {
  THIS_WEEK: {
    from: startOfWeek(today),
    to: endOfWeek(today),
  },
  THIS_MONTH: {
    from: startOfMonth(today),
    to: endOfMonth(today),
  },
  THIS_QUARTER: {
    from: startOfQuarter(today),
    to: endOfQuarter(today),
  },
  THIS_YEAR: {
    from: startOfYear(today),
    to: endOfYear(today),
  },
  LAST_WEEK: {
    from: startOfWeek(lastWeek),
    to: endOfWeek(lastWeek),
  },
  LAST_MONTH: {
    from: startOfMonth(lastMonth),
    to: endOfMonth(lastMonth),
  },
  LAST_QUARTER: {
    from: startOfQuarter(lastQuarter),
    to: endOfQuarter(lastQuarter),
  },
  LAST_YEAR: {
    from: startOfYear(lastYear),
    to: endOfYear(lastYear),
  },
  NEXT_WEEK: {
    from: startOfWeek(nextWeeks(1)),
    to: endOfWeek(nextWeeks(1)),
  },
  NEXT_2_WEEK: {
    from: startOfWeek(nextWeeks(1)),
    to: endOfWeek(nextWeeks(2)),
  },
  NEXT_3_WEEK: {
    from: startOfWeek(nextWeeks(1)),
    to: endOfWeek(nextWeeks(3)),
  },
  NEXT_4_WEEK: {
    from: startOfWeek(nextWeeks(1)),
    to: endOfWeek(nextWeeks(4)),
  },
  NEXT_MONTH: {
    from: startOfMonth(nextMonth),
    to: endOfMonth(nextMonth),
  },
  NEXT_QUARTER: {
    from: startOfQuarter(nextQuarter),
    to: endOfQuarter(nextQuarter),
  },
  NEXT_YEAR: {
    from: startOfYear(nextYear),
    to: endOfYear(nextYear),
  },
}

export function useOnChange(props) {
  let change = useDataChange({
    context: 'ranges',
    path: 'date_range',
    viewPath: props.viewPath,
  })

  return function onChange(range) {
    change(next => {
      next.date_range.from = range.from
      next.date_range.to = range.to
    })
  }
}
